<template>
  <div class="contract-info">
    <div class="title">合同详情</div>
    <div class="detail">
      <div class="detail-info">
        编号：{{ info.contract_no || '—' }}
      </div>
      <div class="detail-info" v-if="info.status === 0" style="color:#999;font-size:13px;">
        合同模板尚未生成，请等待商家确认订单后生成合同。
      </div>
      <div class="detail-info">
        状态：{{ info.status_text }}
      </div>
      <div class="title">
        <div>签署信息</div>
      </div>
      <div class="detail-info">
        <div class="table">
          <div class="tr">
            <div class="th">
              联系电话
            </div>
            <div class="th">
              订单号
            </div>
            <div class="th">
              签署状态
            </div>
            <div class="th">
              发起时间
            </div>
          </div>
          <div class="tr">
            <div class="td">
              {{ info.mobile }}
            </div>
            <div class="td">
              {{ (info.orders && info.orders.order_no) || '' }}
            </div>
            <div class="td">
                  <span
                    :class="
                      info.orders.status_text == '已拒绝' ? 'red' : 'green'
                    "
                  >{{ info.orders.status_text || '' }}</span
                  >
            </div>
            <div class="td">
              {{ info.create_time_text }}
            </div>
          </div>
        </div>
      </div>
      <div class="title">
        <div>合同文件</div>
      </div>
      <div class="detail-info"></div>
      <div class="btns">
        <div class="downLoad" v-if="info.status === 2" @click="download()">下载合同模板</div>
        <div v-if="info.status === 2" style="display: flex;">
          <el-upload class="downLoad file-uploader"
                     action=""
                     accept="application/pdf"
                     :on-change="handleChange"
                     :show-file-list="false"
                     :http-request="uploadFile"
                     :on-success="handleFileSuccess"
                     :before-upload="beforeFileUpload">
            上传签署文件
          </el-upload>
          <span style="font-size: 12px;color: #f00;line-height: 34px">* 仅支持PDF格式，文件大小不能超过5M</span>
        </div>
        <a v-if="info.file" :href="$url.cdn(info.file)" class="downLoad file" target="_blank">查看文件</a>
      </div>
    </div>
  </div>
</template>
<script>
  import contractApi from '@/api/contract'
  import { fileUpload } from "@/units/upload";
  export default {
    data() {
      return {
        info: {orders: {}}
      };
    },
    methods: {
      async getInfo() {
        let {data} =  await contractApi.info.detail(this.$route.params.id)
        this.info = data;
      },
      // 下载
      download() {
        window.open(this.$url.cdn(this.info.tmp_file));
      },
      // 上传文件，获取文件流
      handleChange(file) {
        this.file = file.raw;
      },
      // 上传文件
      async uploadFile(param) {
        let that = this;
        // FormData 对象
        let form = new FormData();
        // 文件对象
        form.append("file", this.file);
        let { data } = await fileUpload(form);
        await contractApi.info.saveFile({'id': that.info.id, 'filePath': data.file.url || ''})
        this.$message({
          message: '文件上传成功！',
          type   : "success"
        });
        setTimeout(res => {
          location.reload();
        }, 2000);
      },
      handleFileSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeFileUpload(file) {
        const isPDF = file.type === "application/pdf";
        const size = 5;
        if (!isPDF) {
          this.$message.error("检查文件格式");
          return false   //必须返回false
        }
        if (file.size > size * 1024 * 1024) {
          this.$message.error("文件大小超出限制！");
          return false   //必须返回false
        }
        return isPDF;
      }
    },
    created() {
      this.$emit("getCompontsIndex", 2);
      this.getInfo();
    }
  };
</script>
<style lang="less" scoped>
  @import url("./index.less");
</style>
